var MediaWidget = {
	media:[],
	uielement: {},
	hasIcon:{},

	setIconStatus: function(symbol, v) {
		MediaWidget.hasIcon[symbol] = v;
		if (MediaWidget.uielement != null && MediaWidget.uielement != undefined) MediaWidget.uielement.__icon_symbol = symbol;
	},

	getIconStatus: function(symbol) {
		return MediaWidget.hasIcon[symbol];
	},

	init: function() {
		MediaWidget.node = $("<a href='javascript:void(null);' id='mediawidget' title='" + TPL.lng("tips.clicktoseevideo", "Kliknij aby oglądnąć film") + "' onclick='MediaWidget.open();'><img src='assets/youtube.png' width='42'></a>");
		MediaWidget.player = $("<div id='mediawidget_player'></div>");
		$("#overlay").append(MediaWidget.node);
		MediaWidget.node.hide();
		$("#overlay").append(MediaWidget.player);

		Tab.setGroup("mediaelement", "+");

		AppEvent.on(player, "placeReady", function(pe) { MediaWidget.placeReady(pe);});

		AppEvent.on(ElementManager, "beforeLoad", function(pe) { MediaWidget.clear(); });

		this.tab = Tab.add('mediaelement', {
			"action": function(m) {
				m.node.click();
			},

			"focus": function(m) {
				m.node.addClass("focused");
				if (m.focus == undefined) m.node.focus();
				else m.focus.focus();
			},

			"blur": function(m) {
				m.node.removeClass("focused");
			},

		}, {"node": $("#mediawidget"), "focus": $("#mediawidget")});

		Tab.disable('mediaelement', this.tab.id);
	},

	addMediaUrl: function(u, qstr) {
		MediaWidget.media = [];
		MediaWidget.media.push(u);
		MediaWidget.node.show();
	},

	showIcon: function(ui, icon, title, symbol) {
		MediaWidget.uielement = ui;
		
		if (symbol != undefined) MediaWidget.setIconStatus(symbol, true);
		else MediaWidget.setIconStatus("default", true);

		if (icon == undefined) {
			MediaWidget.node.html("<img src='assets/youtube.png' width='42'>");
		} else {
			MediaWidget.node.html(icon);
		}

		if (title == undefined) {
			MediaWidget.node.prop("title", TPL.lng("tips.clicktoseevideo", "Kliknij aby oglądnąć film"));
		} else {
			MediaWidget.node.prop("title", title);			
		}

		if (ui != undefined || ui != null) ui.node.addClass("media-hidden");
		if (ui != undefined || ui != null) {
			MediaWidget.node.show();
			Tab.enable('mediaelement', this.tab.id);
		} else {
			MediaWidget.node.hide();
			Tab.disable('mediaelement', this.tab.id);
		}
	},

	clear: function() {
		MediaWidget.media = [];
		if (MediaWidget.uielement == undefined || MediaWidget.uielement == null) MediaWidget.node.hide();
	},

	placeReady: function(pe) {
		//MediaWidget.clear();
	},

	open: function(pe) {
//		console.log("OPEN MEDIA");
//		console.log(MediaWidget.uielement);
		if (MediaWidget.uielement.__icon_symbol != undefined) MediaWidget.setIconStatus(MediaWidget.uielement.__icon_symbol, false);

		if (MediaWidget.uielement != undefined && MediaWidget.uielement.id != undefined) {
			$(".media-hidden").show();
			MediaWidget.node.hide();
			Tab.disable('mediaelement', this.tab.id);
			Tab.enableAll('elements');
		} else {
			MediaWidget.player.show();
			MediaWidget.player.html("<a href='javascript:void(null);' onclick='MediaWidget.close()' class='close'>&times;</a><div class='spacer'></div><div id='yt-fs-player'></div>");//<iframe src='" + MediaWidget.media[0] + "' frameborder='0' allow='autoplay' allowfullscreen></iframe>");
			MediaWidget.yt = YTPlayer.embed("yt-fs-player",MediaWidget.media[0].id, '100%', '100%');
			//MediaWidget.media[0]
		}
	},

	close: function(pe) {
		if (MediaWidget.yt != undefined) YTPlayer.destroy(MediaWidget.yt);

		MediaWidget.player.hide();
		MediaWidget.player.html("");
	}
}

PluginManager.add(MediaWidget);